#back-btn {
  margin-top: calc(var(--spacer) * 2.5);

  &::part(button-text) {
    height: 100%;
  }
}

#easm-related-findings-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-top: calc(var(--spacer) * -2.5);

  #panel-title {
    color: var(--chart-302-icon-buttons-titles);
    padding: calc(var(--spacer) * 7) calc(var(--spacer) * 2) var(--spacer) calc(var(--spacer) * 2);
  }

  gz-text {
    color: var(--body-text-arrows-400);
  }

  #panel-container {
    height: 100%;
    margin: calc(2 * var(--spacer)) 0;
    padding: 0 calc(2 * var(--spacer));

    #input-search {
      margin-bottom: calc(2 * var(--spacer));
      padding-top: var(--spacer);
      padding-bottom: calc(1.5 * var(--spacer));
    }

    #finding-groups-container {
      height: 100%;
      overflow-y: scroll;
    }

    #no-results-message {
      text-align: center;
    }

    .finding-group::part(slotContent) {
      padding: 0;
    }

    .finding-group-title-container {
      display: inline-flex;

      .finding-group-title-text {
        margin-left: calc(var(--spacer) / 2);

        .finding-group-title-count {
          display: inline-flex;

          .finding-group-title,
          .finding-group-count {
            //color: var(--main-titles-inputs-600);
            width: auto;
          }

          .finding-group-title {
            text-transform: uppercase;
            font-size: var(--body-size-small);
            font-weight: 600;
            color: var(--chart-302-icon-buttons-titles);
          }

          .finding-group-count {
            padding-left: calc(var(--spacer) / 2);
          }
        }

        .finding-group-subtitle {
          font-size: 10px;
          text-transform: none;
          color: var(--chart-300-icon-buttons);
        }
      }
    }

    .container {
      display: flex;
      flex-direction: column;
      margin-top: var(--spacer);

      &.has-subtitle-above {
        margin-top: calc(2 * var(--spacer));
      }

      .row {
        display: inline-flex;
        gap: var(--spacer);
        padding-bottom: calc(var(--spacer) * 2.5);

        .column-1 {
          color: var(--chart-300-icon-buttons-titles);
          min-width: 40%;
          text-align: left;

          .finding-name::part(container) {
            padding: 0;
          }
        }

        .column-2 {
          min-width: 45%;
          text-align: left;

          .finding-detail:not(:last-child) {
            margin-bottom: calc(var(--spacer) * 2.5);
          }
        }
      }
    }
  }
}
